import { Link } from './link';

type BBAccountStatus = 'active' | 'inactive' | 'closed' | 'UNKNOWN';

type BBAccountLinks = {
  avatar: Link;
};

type BBUserLinks = BBAccountLinks & {
  followers?: Link;
  following?: Link;
  html?: Link;
  hooks?: Link;
  repositories?: Link;
  self: Link;
  snippets?: Link;
};

type BBUser = {
  has_2fa_enabled?: boolean | null;
  account_id?: string;
  account_status?: BBAccountStatus;
  created_on?: string;
  department?: string | null;
  display_name: string;
  email?: string;
  extra?: {
    has_atlassian_account?: boolean;
    has_ssh_key?: boolean;
    search_state: 'ENABLED' | 'DISABLED';
    workspace_id?: string;
    has_premium?: boolean;
    has_workspace?: boolean;
  };
  is_staff?: boolean;
  job_title?: string | null;
  links: BBUserLinks;
  location?: string | null;
  nickname: string;
  organization?: string | null;
  type: 'user';
  username?: string;
  uuid: string;
  website?: string;
  zoneinfo?: string | null;
};

declare global {
  namespace BB {
    type User = BBUser;
    type AccountStatus = BBAccountStatus;
    type UserLinks = BBUserLinks;
  }
}

export type User = BBUser;
export type UserLinks = BBUserLinks;
export type AccountLinks = BBAccountLinks;
export type AccountStatus = BBAccountStatus;
